// ⬡B:ccwa_core.type_stream:BUILD:phase_1b_cinematic_assembly:20260710⬡
// PHASE 1B of the 2046 JARVIS roadmap: content that visibly builds itself.
// TypeStream is the general live-typing engine, the SkyWriting lineage grown up:
// real text (hers, already generated, never lorem, never placeholder) reveals
// character by character with a live caret, so an email draft or a reply reads
// as being written in front of you. The roadmap law this honors: the reveal
// smooths perceived latency and shows the system producing, and every animation
// must show state changing; this one shows exactly that, the draft coming into
// existence. Duration is capped so long documents never crawl: speed adapts to
// length, minimum 12ms per char, total capped near 6 seconds.
import React, { useEffect, useRef, useState } from 'react';

export function TypeStream({ text = '', onDone, style, caret = true }) {
  const [shown, setShown] = useState(0);
  const timer = useRef(0);
  const full = String(text || '');

  useEffect(() => {
    setShown(0);
    if (!full.length) return undefined;
    const perChar = Math.max(12, Math.min(28, Math.floor(6000 / full.length)));
    let i = 0;
    function step() {
      // reveal in small bursts so long texts flow instead of ticking
      i = Math.min(full.length, i + Math.max(1, Math.round(3 * (18 / perChar))));
      setShown(i);
      if (i < full.length) timer.current = setTimeout(step, perChar);
      else if (onDone) onDone();
    }
    timer.current = setTimeout(step, perChar);
    return () => clearTimeout(timer.current);
  }, [full]);

  const doneTyping = shown >= full.length;
  return (
    <span style={style} data-typestream={doneTyping ? 'done' : 'typing'}>
      {full.slice(0, shown)}
      {caret && !doneTyping ? (
        <span style={{ display: 'inline-block', width: 2, height: '1em', verticalAlign: 'text-bottom',
          background: 'rgba(233,213,255,0.9)', marginLeft: 1, animation: 'aba-caret 0.9s steps(1) infinite' }} />
      ) : null}
    </span>
  );
}

let caretCss = false;
if (typeof document !== 'undefined' && !caretCss) {
  caretCss = true;
  const el = document.createElement('style');
  el.textContent = '@keyframes aba-caret { 0%,49% { opacity: 1; } 50%,100% { opacity: 0; } }';
  document.head.appendChild(el);
}

export default TypeStream;
